import * as React from "react";
import { history } from "../app/router/history";
import { getNavigationState } from "../app/router/navigationState";
import {
    HISTORY_TABLE_HEADER_HEIGHT,
    HISTORY_TABLE_STICKY_TOP,
    HISTORY_TABLE_STICKY_TOP_WITH_REPORT_NAV,
} from "../util/constants";
import { Colors } from "../util/Colors";

const getHistoryTableStickyTop = () => {
    const { reportNavigation } = getNavigationState(history.location);

    return reportNavigation ? HISTORY_TABLE_STICKY_TOP_WITH_REPORT_NAV : HISTORY_TABLE_STICKY_TOP;
};

export const getHistoryTableHeaderCellStyle = (
    stickyHeader: boolean | undefined,
    extra?: React.CSSProperties,
): React.CSSProperties => ({
    verticalAlign: "middle",
    height: HISTORY_TABLE_HEADER_HEIGHT,
    minHeight: HISTORY_TABLE_HEADER_HEIGHT,
    maxHeight: HISTORY_TABLE_HEADER_HEIGHT,
    padding: "8px 4px",
    boxSizing: "border-box",
    ...(stickyHeader
        ? {
              position: "sticky",
              top: getHistoryTableStickyTop(),
              zIndex: 2,
              backgroundColor: Colors.WHITE,
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.06)",
          }
        : undefined),
    ...extra,
});
